module.exports = __webpack_public_path__ + "static/s-exam5-23ca19b3edfd903399706dc57afda510.png";